export default "__VITE_ASSET__BStHFHSn__"